import React from 'react';
import Carousel from './Carousel';
import WideRangeSection from '../pages/WideRangeSection';
import ExploreBrandsSection from '../pages/ExploreBrandsSection';
import AboutUsSection from '../pages/AboutUsSection';
import StepTowardsSection from '../pages/StepTowardsSection';
import VehicleFleetSection from '../pages/VehicleFleetSection';
import WhyChooseUs from '../pages/WhyChooseUs';
import WorkingSteps from '../pages/WorkingSteps';
import Testimonials from '../pages/Testimonials';
import BlogSection from '../pages/BlogSection';
import VideoSlider from './VideoSlider';
import BookingForm from './BookingForm';




const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
              {/* <Carousel/> */}
              <VideoSlider/>
              <BookingForm/>
<WideRangeSection/>
<ExploreBrandsSection/>
<AboutUsSection/>
<StepTowardsSection/>
<VehicleFleetSection/>
<WhyChooseUs/>
<WorkingSteps/>
<Testimonials/>
<BlogSection/>
    </div>
  );
};

export default HeroSection;
